var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.reason === _vm.DeviceUnusableReason.NO_SUPERUSERS
        ? [
            _c("p", [_vm._v(_vm._s(_vm.strings.noSuperusersNotice$()))]),
            _c("p", [_vm._v(_vm._s(_vm.strings.noSuperuserCallToAction$()))]),
          ]
        : _vm.reason === _vm.DeviceUnusableReason.SUPERUSERS_SOFT_DELETED
        ? [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.strings.superusersSoftDeletedNotice$()) +
                  "\n    "
              ),
            ]),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.strings.superusersSoftDeletedCallToAction$()) +
                  "\n    "
              ),
            ]),
          ]
        : _c("p", [_vm._v(_vm._s(_vm.strings.unknownIssueNotice$()))]),
      _c("KButton", {
        staticStyle: { "margin-top": "16px" },
        attrs: {
          disabled: _vm.taskLoading,
          primary: "",
          text: _vm.strings.reinstallKolibriAction$(),
        },
        on: { click: _vm.deprovision },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }